import React from 'react';
import ColorPicker from '../ui/ColorPicker';
import VariableInserter from '../TemplateEditor/VariableInserter';

const CTABlockEditor = ({ block, onUpdate }) => {
  const handleChange = (field, value) => {
    onUpdate(block.id, {
      config: {
        ...block.config,
        [field]: value,
      },
    });
  };

  const handleStyleChange = (field, value) => {
    onUpdate(block.id, {
      styles: {
        ...block.styles,
        [field]: value,
      },
    });
  };

  const handleInsertVariable = (variable) => {
    const currentValue = block.config.primaryUrl || '';
    handleChange('primaryUrl', currentValue + variable);
  };

  return (
    <div>
      <div className="editor-section">
        <h4 className="editor-section-title">Call to Action</h4>

        <div className="editor-field">
          <label>Button Text</label>
          <input
            type="text"
            value={block.config.primaryText || ''}
            onChange={(e) => handleChange('primaryText', e.target.value)}
            placeholder="Primary Button"
          />
        </div>

        <div className="editor-field">
          <label>Button URL</label>
          <input
            type="url"
            value={block.config.primaryUrl || ''}
            onChange={(e) => handleChange('primaryUrl', e.target.value)}
            placeholder="https://example.com"
          />
          <VariableInserter
            onInsert={handleInsertVariable}
            targetField="primaryUrl"
          />
        </div>
      </div>

      <div className="editor-section">
        <h4 className="editor-section-title">Button Styling</h4>

        <ColorPicker
          label="Button Background Color"
          color={block.config.buttonColor || '#FF1493'}
          onChange={(color) => handleChange('buttonColor', color)}
        />

        <ColorPicker
          label="Button Text Color"
          color={block.config.buttonTextColor || '#ffffff'}
          onChange={(color) => handleChange('buttonTextColor', color)}
        />

        <ColorPicker
          label="Background Color"
          color={block.styles.backgroundColor || '#000000'}
          onChange={(color) => handleStyleChange('backgroundColor', color)}
        />

        <div className="editor-field" style={{ marginTop: '1rem' }}>
          <label>Button Alignment</label>
          <select
            value={block.styles.textAlign || 'center'}
            onChange={(e) => handleStyleChange('textAlign', e.target.value)}
          >
            <option value="left">Left</option>
            <option value="center">Center</option>
            <option value="right">Right</option>
          </select>
        </div>

        <div className="editor-field">
          <label>Button Border Radius (px)</label>
          <input
            type="number"
            value={block.config.borderRadius || 8}
            onChange={(e) => handleChange('borderRadius', parseInt(e.target.value))}
            min="0"
            max="50"
          />
        </div>
      </div>
    </div>
  );
};

export default CTABlockEditor;
